import { render, staticRenderFns } from "./MpotList.vue?vue&type=template&id=7a90558d&scoped=true&"
import script from "./MpotList.vue?vue&type=script&lang=js&"
export * from "./MpotList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a90558d",
  null
  
)

export default component.exports